module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/athena-club-58493a3639ccf6dd112c64a03e385663.svg";